// extracted by mini-css-extract-plugin
export var modalFooter = "_ov-0";